module.exports = __webpack_public_path__ + "static/media/MW.9a092b17.svg";